import React, { useState } from "react";
import { questions } from "./Data";
import Overall from "./OverallResult";
import DomainResults from "./DomainResults";
import "./EmotionalIntelligence.css";
import { connect } from "react-redux";
import { myFirestore } from "../../../services/firebase";

let selfAwareness = 0,
  managingEmotions = 0,
  motivatingOneself = 0,
  empathy = 0,
  handlingRelationships = 0;

let EI = 0;

function ScoreCard(props) {
  return (
    <div className="result-div-ei">
      <h3>Your Results</h3>
      <Overall EI={EI} />
      <DomainResults
        selfAwareness={selfAwareness}
        managingEmotions={managingEmotions}
        motivatingOneself={motivatingOneself}
        empathy={empathy}
        handlingRelationships={handlingRelationships}
      />
    </div>
  );
}

function EmotionalIntelligenceQuiz(props) {
  const [qno, setQno] = useState(0);
  let [ansArrayPos] = useState([]);
  let [ansArrayNeg] = useState([]);
  const [show, setShow] = useState(true);

  let ansPos = 0;
  let ansNeg = 0;

  function computeScore() {
    selfAwareness =
      ansArrayPos[0] +
      ansArrayPos[12] +
      ansArrayPos[15] +
      ansArrayPos[35] +
      ansArrayPos[39] +
      ansArrayPos[43] +
      ansArrayPos[49] +
      ansArrayPos[57] +
      ansArrayNeg[10] +
      ansArrayNeg[13] +
      ansArrayNeg[20] +
      ansArrayNeg[25] +
      ansArrayNeg[30] +
      ansArrayNeg[46];

    managingEmotions =
      ansArrayPos[5] +
      ansArrayPos[7] +
      ansArrayPos[16] +
      ansArrayPos[31] +
      ansArrayPos[47] +
      ansArrayPos[54] +
      ansArrayNeg[1] +
      ansArrayNeg[6] +
      ansArrayNeg[8] +
      ansArrayNeg[11] +
      ansArrayNeg[21] +
      ansArrayNeg[26] +
      ansArrayNeg[28] +
      ansArrayNeg[52];

    motivatingOneself =
      ansArrayPos[2] +
      ansArrayPos[17] +
      ansArrayPos[22] +
      ansArrayPos[27] +
      ansArrayPos[32] +
      ansArrayPos[40] +
      ansArrayPos[44] +
      ansArrayPos[51] +
      ansArrayNeg[36] +
      ansArrayNeg[50];

    empathy =
      ansArrayPos[3] +
      ansArrayPos[18] +
      ansArrayPos[41] +
      ansArrayPos[48] +
      ansArrayNeg[23] +
      ansArrayNeg[33];

    handlingRelationships =
      ansArrayPos[4] +
      ansArrayPos[9] +
      ansArrayPos[14] +
      ansArrayPos[19] +
      ansArrayPos[34] +
      ansArrayPos[37] +
      ansArrayPos[38] +
      ansArrayPos[42] +
      ansArrayPos[45] +
      ansArrayPos[56] +
      ansArrayPos[58] +
      ansArrayPos[59] +
      ansArrayNeg[24] +
      ansArrayNeg[29] +
      ansArrayNeg[53] +
      ansArrayNeg[55];

    EI =
      selfAwareness +
      managingEmotions +
      motivatingOneself +
      empathy +
      handlingRelationships;

    if (props.auth.uid) {
      myFirestore
        .collection("testresults")
        .doc(props.auth.uid)
        .set(
          {
            EI: {
              selfAwareness: selfAwareness,
              managingEmotions: managingEmotions,
              motivatingOneself: motivatingOneself,
              empathy: empathy,
              handlingRelationships: handlingRelationships,
            },
          },
          { merge: true }
        );
    } else {
      myFirestore
        .collection("anonresults")
        .doc()
        .set({
          EI: {
            selfAwareness: selfAwareness,
            managingEmotions: managingEmotions,
            motivatingOneself: motivatingOneself,
            empathy: empathy,
            handlingRelationships: handlingRelationships,
          },
        });
    }
  }

  function handleClick(e) {
    ansPos = parseInt(e.target.getAttribute("data-value-pos"));
    ansNeg = parseInt(e.target.getAttribute("data-value-neg"));
    ansArrayPos.push(ansPos);
    ansArrayNeg.push(ansNeg);
    setQno((prev) => prev + 1);
    if (qno + 1 === 60) {
      setShow(false);
      computeScore();
    }
  }

  return (
    <div className="screen-bg">
      {show ? (
        <div className="quiz-bg">
          <p>Question {qno + 1} of 60</p>
          <h3>{questions[qno]}</h3>
          <div className="answers">
            <div data-value-pos="5" data-value-neg="1" onClick={handleClick}>
              Always
            </div>
            <div data-value-pos="4" data-value-neg="2" onClick={handleClick}>
              Most Often
            </div>
            <div data-value-pos="3" data-value-neg="3" onClick={handleClick}>
              Occasionally
            </div>
            <div data-value-pos="2" data-value-neg="4" onClick={handleClick}>
              Rarely
            </div>
            <div data-value-pos="1" data-value-neg="5" onClick={handleClick}>
              Never
            </div>
          </div>
        </div>
      ) : (
        <ScoreCard />
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
    profile: state.firebase.profile,
  };
};

export default connect(mapStateToProps)(EmotionalIntelligenceQuiz);
